import * as Yup from "yup";

export const ERROR_MSG = " Required";
export const IFSC_VALIDATION = /^[A-Z]{4}0[A-Z 0-9]{6}$/;

export const AADHAR_VALIDATION = /^[1-9]{1}[0-9]{11}$/;
export const MOBILE_VALIDATION = /^[6-9]{1}[0-9]{9}$/;
export const Email_Validation = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;


export const PAN_VALIDATION = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
export const PINCODE = /^[1-9]{1}[0-9]{5}$/;
export const ApPINCODE = /^5[0-9]{5}$/;

export const NUMERIC = /^\d+$/;
export const ALPHABETS_ONLY = /^[aA-zZ\s]+$/;
export const STARTS_WITH_NO_WHITESPACE = /^(?!\s+$).*/;
export const AC_YEAR_OLD = "2024-25";
export const AC_YEAR = "2025-26";
export const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
export const faxRegex = /^(\+91[\-]?)?(\d{2,4})-\d{6,8}$/;
export const pantanRegex = /^([A-Z]{5}[0-9]{4}[A-Z]|[A-Z]{4}[0-9]{5}[A-Z])$/i;



// ✅ Mobile Number
export const mobileValidation = Yup.string()
    .required("Mobile number is required")
    .matches(/^[6-9]\d{9}$/, "Enter valid 10-digit mobile number");

// ✅ Email
export const emailValidation = Yup.string()
    .trim()
    .required("Email is required")
    .matches(
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
        "Enter a valid email address"
    );

// ✅ Aadhaar
export const aadhaarValidation = Yup.string()
    .required("Aadhaar is required")
    .matches(/^\d{12}$/, "Aadhaar must be 12 digits");

// ✅ Only Text (alphabets + spaces)
export const textValidation = Yup.string()
    .required("This field is required")
    .matches(/^[A-Za-z\s]+$/, "Only alphabets allowed");

// ✅ Only Numbers
export const numberValidation = Yup.string()
    .required("This field is required")
    .matches(/^\d+$/, "Only numbers allowed");

// ✅ Required Select
export const selectValidation = Yup.string()
    .required("Please select an option");

// ✅ Date (no future)
export const dateValidation = Yup.date()
    .required("Date is required")
    .max(new Date(), "Future date not allowed");

export const pincodeValidation = Yup.string()
    .required("Pincode is required")
    .matches(/^[1-9][0-9]{5}$/, "Enter valid 6-digit pincode");


export const validateVerhoeff = (aadhaarNumber) => {
    const d = [
        [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
        [1, 2, 3, 4, 0, 6, 7, 8, 9, 5],
        [2, 3, 4, 0, 1, 7, 8, 9, 5, 6],
        [3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
        [4, 0, 1, 2, 3, 9, 5, 6, 7, 8],
        [5, 9, 8, 7, 6, 0, 4, 3, 2, 1],
        [6, 5, 9, 8, 7, 1, 0, 4, 3, 2],
        [7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
        [8, 7, 6, 5, 9, 3, 2, 1, 0, 4],
        [9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
    ];

    const p = [
        [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
        [1, 5, 7, 6, 2, 8, 3, 0, 9, 4],
        [5, 8, 0, 3, 7, 9, 6, 1, 4, 2],
        [8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
        [9, 4, 5, 3, 1, 2, 6, 8, 7, 0],
        [4, 2, 8, 6, 5, 7, 3, 9, 0, 1],
        [2, 7, 9, 3, 8, 0, 6, 4, 1, 5],
        [7, 0, 4, 6, 9, 1, 3, 2, 5, 8],
    ];

    let c = 0;
    const invertedArray = aadhaarNumber.split('').map(Number).reverse();

    for (let i = 0; i < invertedArray.length; i++) {
        c = d[c][p[i % 8][invertedArray[i]]];
    }

    return c === 0;
};
